import { Component } from "@angular/core";
import { Router } from "@angular/router";
import { UserService } from "../../services/user.service";

@Component({
        standalone: false,
    templateUrl: "./logout.component.html",
})
export class LogoutPage {
    constructor(private userService: UserService, private router: Router) {}

    ngOnInit() {
        this.userService.logout().subscribe();

        this.router.navigateByUrl("login");
    }
}
